import { pipe } from 'fp-ts/function';
import { parse } from 'qs';
export var getParam = function getParam(param, location) {
  return pipe(location.search, function (searchParams) {
    return parse(searchParams, {
      ignoreQueryPrefix: true
    });
  }, function (parsedParams) {
    return parsedParams[param];
  });
};